"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAppId = void 0;
exports.requestAppId = {
    Wrap: {
        appIds: [1],
        default: 1,
    },
    WrapAndSwap: {
        appIds: [10, 20],
        default: 20,
        uniswapV2Swap: 10,
        uniswapV3Swap: 20,
    },
};
//# sourceMappingURL=request-types.js.map